import React from 'react';
import { School } from 'lucide-react';

const AcademicInfoCard = ({ inscription }) => {
  if (!inscription) return null;

  return (
    <div className="bg-white rounded-lg shadow-sm border overflow-hidden">
      <div className="bg-[#f8f9fa] border-b px-4 py-3">
        <h2 className="text-lg font-semibold text-[#202654] flex items-center">
          <School className="h-5 w-5 mr-2 text-[#202654]" />
          Informations académiques
        </h2>
      </div>
      <div className="p-4">
        <div className="grid grid-cols-2 gap-4">
          <div className="p-3 bg-[#f8f9fa] rounded-lg">
            <div className="text-xs text-gray-500 mb-1">Filière</div>
            <div className="font-semibold text-[#202654]">{inscription.filiere?.libelle}</div>
          </div>
          <div className="p-3 bg-[#f8f9fa] rounded-lg">
            <div className="text-xs text-gray-500 mb-1">Niveau</div>
            <div className="font-semibold text-[#202654]">{inscription.niveau?.libelle}</div>
          </div>
          <div className="p-3 bg-[#f8f9fa] rounded-lg">
            <div className="text-xs text-gray-500 mb-1">Année académique</div>
            <div className="font-semibold text-[#202654]">{inscription.annee?.libelle}</div>
          </div>
          <div className="p-3 bg-[#f8f9fa] rounded-lg">
            <div className="text-xs text-gray-500 mb-1">Date d'inscription</div>
            <div className="font-semibold text-[#202654]">{new Date(inscription.date_inscription).toLocaleDateString('fr-FR')}</div>
          </div>
        </div>

        {inscription.options && inscription.options.length > 0 && (
          <div className="mt-4">
            <div className="bg-[#f8f9fa] px-3 py-2 rounded-md mb-2">
              <h3 className="text-[#202654] font-semibold text-sm">Options complémentaires</h3>
            </div>
            <div className="space-y-2">
              {inscription.options.map((option, index) => (
                <div key={index} className="flex justify-between items-center border-b border-gray-100 pb-2">
                  <span className="text-gray-700">{option.option_libelle}</span>
                  <span className="font-medium">{option.option_prix?.toLocaleString()} FCFA</span>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AcademicInfoCard;
